import app from '../../forum/app';
import Component from '../../common/Component';
import SelectDropdown from '../../common/components/SelectDropdown';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
import ThemeMode, { ColorScheme } from '../../common/components/ThemeMode';
const DEFAULT_ICON = 'fa-solid fa-circle-half-stroke';
export default class ThemeSwitcher extends Component {
  iconItems() {
    const items = new ItemList();
    items.add(ColorScheme.Light, 'fa-regular fa-sun');
    items.add(ColorScheme.LightHighContrast, 'fa-solid fa-sun');
    items.add(ColorScheme.Dark, 'fa-regular fa-moon');
    items.add(ColorScheme.DarkHighContrast, 'fa-solid fa-moon');
    return items;
  }
  icon(scheme) {
    const items = this.iconItems();
    return items.has(scheme) ? items.get(scheme) : DEFAULT_ICON;
  }
  active() {
    return app.colorScheme ?? app.session.user?.preferences()?.colorScheme ?? app.forum.attribute('colorScheme') ?? ColorScheme.Auto;
  }
  label(scheme) {
    const custom = ThemeMode.colorSchemes.find(s => s.id === scheme)?.label;
    return custom || app.translator.trans('core.forum.settings.color_schemes.' + scheme.replace('-', '_') + '_mode_label', {}, true);
  }
  select(scheme) {
    app.setColorScheme(scheme);
    if (app.session.user) {
      app.session.user.savePreferences({
        colorScheme: scheme
      });
    } else {
      try {
        sessionStorage.setItem('colorScheme', scheme);
      } catch (e) {
        // The browser blocks storage: the scheme applies until the page is left.
      }
    }
    m.redraw();
  }
  view() {
    const active = this.active();
    const resolved = active === ColorScheme.Auto ? app.getSystemColorSchemePreference() : active;
    return m(SelectDropdown, {
      className: "ThemeSwitcher HeaderDropdown",
      buttonClassName: "Button Button--flat",
      icon: this.icon(resolved),
      noStyleOverride: true,
      defaultLabel: this.label(active),
      accessibleToggleLabel: app.translator.trans('core.forum.header.theme_switcher_accessible_label')
    }, ThemeMode.colorSchemes.map(scheme => m(Button, {
      className: `ThemeSwitcher-option ThemeSwitcher-option--${scheme.id}`,
      icon: active === scheme.id ? 'fa-solid fa-check' : this.icon(scheme.id),
      noStyleOverride: true,
      active: active === scheme.id,
      onclick: () => this.select(scheme.id)
    }, this.label(scheme.id))));
  }
}
flarum.reg.add('core', 'forum/components/ThemeSwitcher', ThemeSwitcher);